import { useCallback, useRef, useState } from 'react';
import { ebGlobalChannel } from 'src/lib/events-bridge';
import useSubscription from 'src/lib/events-bridge/hooks/useSubscription';
import EBAPIs from 'src/lib/events-bridge/topics';
import { getDuration, snackbarIdGenerator } from './utils';
const DUMMY_ACTION = {
    title: '',
    onPress() { },
};
function addDefaultValues(data) {
    return {
        variant: 'NEUTRAL',
        action: DUMMY_ACTION,
        ...data,
    };
}
export default function useSnackbar() {
    const [state, setState] = useState({
        id: 0,
        visible: false,
        variant: 'NEUTRAL',
        message: '',
        action: DUMMY_ACTION,
    });
    const timer = useRef(undefined);
    const show = useCallback((id, snackbarData) => {
        clearTimeout(timer.current);
        setState({
            id,
            ...addDefaultValues(snackbarData),
            visible: true,
        });
        timer.current = setTimeout(() => {
            setState(prevState => {
                return {
                    ...prevState,
                    visible: false,
                };
            });
        }, getDuration(snackbarData.message, snackbarData.duration || 'SHORT'));
    }, []);
    useSubscription(EBAPIs.helperViews.snackbar.show, useCallback((snackbarData) => {
        const mySnackbarId = snackbarIdGenerator.getNew();
        show(mySnackbarId, snackbarData);
    }, [show]));
    return [state];
}
export const snackbarHelperActions = {
    show(data) {
        ebGlobalChannel.publish(EBAPIs.helperViews.snackbar.show, data);
    },
};
